import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';
import { usePoints } from '../context/PointsContext';
import './Footer.css';

const Footer = () => {
  const { user, getFreshToken } = useAuth();
  const { triggerPointsAnimation } = usePoints();
  const [clickedNetworks, setClickedNetworks] = useState([]);

  const handleSocialClick = async (e, network, url) => {
    console.log(">>> [FRONTEND] handleSocialClick triggered for:", network);
    // Captura posição do clique
    const clickX = e.clientX;
    const clickY = e.clientY;
    console.log(">>> [FRONTEND] Click position:", clickX, clickY);

    // Abre a rede social imediatamente
    window.open(url, '_blank');

    // Se usuário logado, tenta pontuar
    if (user && !clickedNetworks.includes(network)) {
      console.log(">>> [FRONTEND] User logged in, sending request...");
      try {
        const token = await getFreshToken();
        if (!token) return;

        const response = await axios.post(`${process.env.REACT_APP_API_URL}/points/social-click`,
          { network },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        console.log(">>> [FRONTEND] Response:", response.data);

        if (response.data.rewarded) {
          setClickedNetworks(prev => [...prev, network]);
          console.log(">>> [FRONTEND] Triggering animation...");
          triggerPointsAnimation(30, clickX, clickY);
        } else {
          console.log(">>> [FRONTEND] Not rewarded:", response.data.message);
        }
      } catch (error) {
        console.error("Erro ao registrar ponto social:", error);
      }
    } else {
      console.log(">>> [FRONTEND] Conditions not met: User?", !!user, "Already clicked?", clickedNetworks.includes(network));
    }
  };

  return (
    <footer style={{ backgroundColor: 'var(--background-white)', borderTop: '1px solid var(--border-color)', padding: 'var(--spacing-xl) 0', marginTop: 'var(--spacing-xl)' }}>
      <div className="container">
        <div className="grid grid-cols-1 grid-md-3" style={{ gap: 'var(--spacing-lg)' }}>
          <div>
            <h3 style={{ color: 'var(--text-primary)', marginBottom: 'var(--spacing-md)' }}>Sobre o Mercado Íntimo</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)' }}>
              Mercado Íntimo é o seu universo de bem-estar íntimo e agregador de ofertas premium. Encontre lingeries, sextoys, cosméticos sensuais e muito mais com total discrição e descontos imperdíveis.
            </p>

            {/* Social Buttons */}
            <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
              <button
                onClick={(e) => handleSocialClick(e, 'instagram', 'https://www.instagram.com/mercado.intimo')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '24px', color: '#E1306C' }}
                title="Siga no Instagram (+30 moedas)"
              >
                <i className="fab fa-instagram"></i>
                {clickedNetworks.includes('instagram') && <i className="fas fa-check-circle" style={{ fontSize: '12px', color: 'green', marginLeft: '-5px', verticalAlign: 'top' }}></i>}
              </button>
              <button
                onClick={(e) => handleSocialClick(e, 'youtube', 'https://www.youtube.com/@MercadoIntimo')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '24px', color: '#FF0000' }}
                title="Inscreva-se no YouTube (+30 moedas)"
              >
                <i className="fab fa-youtube"></i>
                {clickedNetworks.includes('youtube') && <i className="fas fa-check-circle" style={{ fontSize: '12px', color: 'green', marginLeft: '-5px', verticalAlign: 'top' }}></i>}
              </button>
            </div>

          </div>
          <div>
            <h3 style={{ color: 'var(--text-primary)', marginBottom: 'var(--spacing-md)' }}>Links Úteis</h3>
            <ul style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)' }}>
              <li style={{ marginBottom: 'var(--spacing-sm)' }}><Link to="/">Home</Link></li>
              <li style={{ marginBottom: 'var(--spacing-sm)' }}><Link to="/favoritos">Favoritos</Link></li>
            </ul>
          </div>
          <div>
            <h3 style={{ color: 'var(--text-primary)', marginBottom: 'var(--spacing-md)' }}>Contato</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)' }}>
              Email: contato@mercadointimo.com.br<br />
              Telefone: (19)99351-1031
            </p>
          </div>
        </div>
        <div style={{ borderTop: '1px solid var(--border-color)', marginTop: 'var(--spacing-lg)', paddingTop: 'var(--spacing-md)', display: 'flex', justifyContent: 'center', color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)' }}>
          <div>&copy; {new Date().getFullYear()} Mercado Íntimo. Todos os direitos reservados.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
